import React from 'react';
import CustomPrimaryButton from '../../../components/globals/CustomPrimaryButton';
import CustomSecondaryButton from '../../../components/globals/CustomSecondaryButton';
import LogoCom from './LogoCom';
import { useNavigate } from 'react-router-dom';

const Header = () => {

    const navigate = useNavigate();

    return (
        <header class="custom-color-header text-white py-2">
            <div class="container">
                <div class="d-flex align-items-center justify-content-between">
                    <LogoCom />
                    <div class="buttons d-flex me-5">
                        <CustomPrimaryButton
                            btnTextPro="Login"
                            classNamePro="btn btn-primary mt-2"
                            handleOnClick={() => {
                                navigate("/webapp");
                            }}
                        />
                        <CustomSecondaryButton
                            btnTextPro="Register"
                            classNamePro="btn btn-seondary"
                            handleOnClick={() => {
                                navigate("/webapp");
                            }}
                        />
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header;
